"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasteData = exports.IsDefault = void 0;
var lodash_1 = __importDefault(require("lodash"));
function IsDefault(record, columns, isDefault, defaultCode) {
    var recordIsDefault = isDefault;
    if (defaultCode && !isDefault) {
        var validateDefaultColumn = lodash_1.default.find(columns, function (column) {
            return column.validateDefault;
        });
        if (validateDefaultColumn) {
            recordIsDefault = record[validateDefaultColumn.columnKey] === defaultCode;
        }
    }
    return recordIsDefault;
}
exports.IsDefault = IsDefault;
function PasteData(columnKey, clipboardData, requireFields) {
    if (requireFields === void 0) { requireFields = []; }
    var lines = clipboardData.split(/\r?\n/);
    var records = [];
    lines.forEach(function (line) {
        if (line && line.length > 0) {
            var data_1 = line.split('	'); // Tab
            if (data_1.length >= 1) {
                var record_1 = {
                    uniqueId: lodash_1.default.uniqueId(),
                    isNew: true,
                };
                requireFields.forEach(function (column, index) {
                    record_1[column] = column === columnKey ? data_1[0] : '';
                });
                records = __spreadArray(__spreadArray([], records, true), [record_1], false);
            }
        }
    });
    return records;
}
exports.PasteData = PasteData;
